<template>


  <div class="about">
 

<h2>
    Your Locations
</h2>
<div class="d-flex flex-wrap">
<location-tile v-for="(i, index) in getLocations" :location="i" :key="index">

</location-tile>

    <v-card class="mb-5" max-width="374" min-width="300" min-height="200"  @click="createLocation()">
  <v-card-text> 
    <v-icon>mdi-plus-circle</v-icon>
          Add New Location
  </v-card-text>
      </v-card>

  </div>
</div>
</template>



<script>
  import LocationTile from '@/components/Locations/LocationSplashTile.vue';
  import { mapActions } from 'vuex';
  import {mapGetters} from 'vuex';


export default {
  name: 'Home',
  
  created: function () {
    // `this` points to the vm instance
    this.loadClients()
  
  },
  computed:{
      ...mapGetters(["getLocations"])
  },
  data(){
    return {  
      locations:[{Title:"Main Location", Id:"id1"},
     {Title:"Location 2", Id:"id2"} 
      ],
       data2:{
            labels:['','','','','','',''],
            datasets:[{data:[1,5,6,7,7,8,9]}]

        },
    }
  },

  methods: {
    
    ...mapActions([
      "loadClients",
      "addLocation"
    ]),
    createLocation(){
        this.addLocation().then(response=>{
          
          
          });
    },
      navigateVenue(id){
        this.$router.push('venue/' + id);
      }
  },
  components: {
    LocationTile
  }
}
</script>

